import React from "react";
import { JourneyShell } from "./src/components/journey/journey-shell";

export const wrapRootElement = ({ element }) => (
    <JourneyShell>{element}</JourneyShell>
);

export const onRouteUpdate = () => {
    window.dispatchEvent(new Event("studio-route-change"));
    if (/^\/(?:en\/|ja\/)?blog\/[^/]+/.test(window.location.pathname)) {
        try {
            const snapshot = JSON.parse(
                window.sessionStorage.getItem("studio-locale-switch-state")
            );
            window.sessionStorage.removeItem("studio-locale-switch-state");
            if (snapshot)
                requestAnimationFrame(() =>
                    window.scrollTo({
                        left: snapshot.x,
                        top: snapshot.y,
                        behavior: "instant",
                    })
                );
        } catch (_) {
            /* Language navigation still works without browser storage. */
        }
    }
};

export const shouldUpdateScroll = () => {
    try {
        if (
            window.sessionStorage.getItem("studio-locale-switch-pending") ===
            "1"
        ) {
            window.sessionStorage.removeItem("studio-locale-switch-pending");
            return false;
        }
    } catch (_) {
        // Fall through to Gatsby's default route scroll behavior.
    }

    return true;
};
